 function init_jeelizAutoVTO(){
    console.log('Init Jeeliz AutoVTO');
    const buttonCSSStyle = [
      // Style your VTObutton here:
      'font-size: 12px',
      'letter-spacing: 0.96px',
      'font-variant: small-caps',
      'padding: 10px 20px',
      'margin-top: 0px',
      'margin-bottom: 0px',
      'border: #3c65c8 solid 1px',
      'cursor: pointer',
      'color:#3c65c8',
      'max-width:186px',
      'background-color: #ffffff',
      'text-decoration: underline!important',
      'float:right',
      'border-radius:20px',
      'position: absolute',
       'top: -40px',
       'right: 0',
      ];
     const buttonCSSStylemobile = [
      // Style your VTObutton here:
      'font-size: 12px',
      'letter-spacing: 0.96px',
      'font-variant: small-caps',
      'padding: 10px 20px',
      'margin-top: 0px',
      'margin-bottom: 0px',
      'border: unset',
      'cursor: pointer',
      'color:#3c65c8',
      'max-width:186px',
      'background-color: #ffffff',
      'text-decoration: underline!important',
      'float:right',
      'border-radius:20px',
       'position: absolute',
       'bottom: 30px',
       'right: 0',
       'text-transform: none',
       'z-index: 999'
      ];

    // optional: for debugging purpose, we only display the VTO button if there is 
    // the URL parameters debugVTO in the URL
    // IT SHOULD BE REMOVED IN PRODUCTION
    /*if (!location.href.includes('debugVTO')){
      buttonCSSStyle.push('display: none');
    } //*/

   function getVTOButtonSource() {
    // 根据屏幕宽度小于768px的条件应用不同的样式
     // 按钮
     // return (window.innerWidth < 768) ? '<button style="' + buttonCSSStylemobile.join(';') + '">try on</button>' :
                                      // '<button style="' + buttonCSSStyle.join(';') + '">Try On</button>';
}

    JEELIZAUTOVTO.init({
      // Insert the button before the "Add to bag" button:
      // Where we should append the VTO button:
      VTOButtonAnchor: $('.main-image')[0],

      // how we use the anchor. Possible values are 'inside', 'before', 'after'
      VTOButtonAnchorType: 'before',

      // Source code of the virtual try-on button:
      VTOButtonSource: getVTOButtonSource(),

      // HTML source or element displayed with the modal background when the user clicks on the VTO button
      // Useful to implement scale changes depending on man / woman, or display GDPR notices
      // and before the start of the VTO session.
      // it can call these methods:
      //   * JEELIZAUTOVTO.resume_beforeStart() to take of the HTML code and resume VTO
      //   * JEELIZAUTOVTO.cancel_beforeStart() to cancel VTO
      //   * JEELIZAUTOVTO.update_adjustment({scale: <scale>}) to set a custom scale factor
      VTOBeforeStart: null,

      // Model selector, displayed in the VTO view
      // It can be either HTML source code (provided as a string), or DOM elements
      // it can call JEELIZAUTOVTO.load_modelFromUrl(otherModelProductPageUrl) to change the current model
      VTOSwitchModels: null, /*"<button onClick=\"JEELIZAUTOVTO.load_modelFromUrl('https://www.lakoh.com/products/lena?variant=44181934571746')\""
         + "style='margin: 20px'>Change model</button>",*/

      // color of the background of the VTP modal window:
      modalBackgroundColor: 0x000000,

      // opacity of the VTO modal window:
      modalBackgroundOpacity: 0.7,

      // set this value to 0 to display VTO view in full height (default)
      VTOViewHeight: 800,

      // image used when we look for the face:
      // it should be a square white image, with a black background
      // dimensions should be Power of Two (512x512 pixels or 1024x1024 pixels)
      // the black will be displayed with transparent
      // and the white with the color specified in the faceSearchImageColor property
      // open https://appstatic.jeeliz.com/jeewidget/images/target.png as an example
      faceSearchImageMask: 'https://appstatic.jeeliz.com/jeewidget/images/target.png',

      // color of the loading image:
      faceSearchImageColor: 0xeeeeee,

      // enable shadows on the glasses:
      isShadow: false,

      // list of URL parameters kept for the product page URL:
      protectedURLParams: ['variant'],

      // function receiving location.href as argument, and returning a tweaked locationHref
      // the goal of this function is to avoid duplicates in product pages URL:
      // If we have different product page URLs for the same product, this function can be used
      // to return a unique URL for all of them.
      // in most cases it is not useful since having different URLs for the same product page
      // is not good for SEO
      locationHrefTweaker: function(loc){
        // check if the variant is included in the URL:
        if (loc.includes('variant=')){
          // the product variant is already included in the current page URL
          return loc;
        }
        // the variant is not included.
        // We need to include it to avoid having 2 product pages URL for the same product
        // For example:
        //   * https://www.lakoh.com/products/lena
        //   * https://www.lakoh.com/products/lena?variant=44338832933090
        let variant = null;
        if (meta && meta.product
          && meta.product.variants && meta.product.variants.length){
          variant = meta.product.variants[0].id;
        }
        if (!variant){
          return loc;
        }
        const sep = (loc.includes('?')) ? '&' : '?';
        return loc + sep + 'variant=' + variant;
      },

      // if true, display the VTO button with a debug SKU
      debugAlwaysDisplay: false,

      // callbacks to implement custom analytics:
      onVTOSessionStart: function(){ // the VTO session really starts
        console.log('VTO Session start');
      },

      onVTOSessionEnd: function(durationMs){ // the VTO session ends or the page is closed.
        console.log('VTO Session ends. Duration = ', durationMs.toString() + 'ms');
      },

      onVTOError: function(errorLabel){ // for some reason the VTO session cannot start
        console.log('VTO session cannot start. Error:', errorLabel);
      },

      onVTOButtonDisplay: function(DOMButtonElement){ // the VTO button is displayed
        console.log('Display VTO button');
      },

      onVTOButtonClick: function(clickEvent){ // the user clicks on the VTO button
        console.log('Click on VTO button');
      }
    });
  }
  window.addEventListener('load', init_jeelizAutoVTO);